import { all } from "redux-saga/effects";
import testSagas from "./tests-sagas";
import logger from "./logger";
import notificationSaga from "./notificationSaga";

export default function*() {
  yield all([testSagas(), logger(), notificationSaga()]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js